import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TRANSITION_TIME_DEFAULT } from '../../../../config/constants';

const verticalSlideWrapperStyles = {
    height: 0,
    transition: `height ${TRANSITION_TIME_DEFAULT}s linear`,

    overflow: 'hidden',
    padding: 0
};
const resetVerticalSlideWrapperStyles = {
    height: '',
    transition: '',
    overflow: '',
    padding: ''
};

const verticalSlideInnerWrapperStyles = {
    position: 'absolute',
    width: '100%',
    bottom: 0
};
const resetVerticalSlideInnerWrapperStyles = {
    position: '',
    width: '',
    bottom: '',
    padding: ''
};


/*
 HOW TO USE
 // Include the Component from shared
 <VerticalSlideIn>

     //The Element which should slide in vertical (class wrapper not mandatory)
     <div styleName="wrapper">

         // needs to be added so the Element can slide in from top to bottom
         <div className="vertical-slide-inner-wrapper">
             ...
             ...
         </div>
     </div>
 </VerticalSlideIn>
 */


/* eslint-disable react/jsx-no-bind */
// TODO Get rid of componentDidMount to avoid unnecessary rerending
export class VerticalSlideIn extends Component {

    render () {
        return (
            <div ref={(elem) => { this.wrapperElem = elem; }}>
                {this.props.children}
            </div>
        );
    }

    setStylesToTransitionTo() {
        setTimeout(() => {
            this.verticalSlideWrapper.style.height = `${this.verticalSlideInnerWrapper.scrollHeight}px`;
        }, 10);
    }

    setStylesToWrappers() {
        if (this.verticalSlideInnerWrapper) {
            Object.assign(this.verticalSlideInnerWrapper.style, verticalSlideInnerWrapperStyles);
            this.addPaddingFromVerticalSlideWrapper();
        }
        Object.assign(this.verticalSlideWrapper.style, verticalSlideWrapperStyles);
    }

    componentDidMount() {
        if (this.props.isVerticalSlideInEnabled) {
            this.verticalSlideWrapper = this.wrapperElem.children[0];
            this.verticalSlideInnerWrapper = this.verticalSlideWrapper.querySelector('.vertical-slide-inner-wrapper');
            this.verticalSlideWrapper.addEventListener('transitionend', this.resetStyles);
            this.setStylesToWrappers();
            this.setStylesToTransitionTo();
        }
    }

    componentWillUnmount() {
        if (this.verticalSlideWrapper && this.props.isVerticalSlideInEnabled) {
            this.verticalSlideWrapper.removeEventListener('transitionend', this.resetStyles);
        }
    }

    resetStyles() {
        const wrapper = this;
        const slideInnerWrapper = this.querySelector('.vertical-slide-inner-wrapper');
        if (slideInnerWrapper) {
            Object.assign(slideInnerWrapper.style, resetVerticalSlideInnerWrapperStyles);
        }
        Object.assign(wrapper.style, resetVerticalSlideWrapperStyles);
    }

    addPaddingFromVerticalSlideWrapper() {
        const {
            paddingLeft,
            paddingRight,
            paddingBottom,
            paddingTop
        } = window.getComputedStyle(this.verticalSlideWrapper, null);
        this.verticalSlideInnerWrapper.style.paddingLeft = paddingLeft;
        this.verticalSlideInnerWrapper.style.paddingRight = paddingRight;
        this.verticalSlideInnerWrapper.style.paddingBottom = paddingBottom;
        this.verticalSlideInnerWrapper.style.paddingTop = paddingTop;
    }
}

VerticalSlideIn.propTypes = {
    children: PropTypes.any.isRequired,
    isVerticalSlideInEnabled: PropTypes.bool
};

VerticalSlideIn.defaultProps = {
    isVerticalSlideInEnabled: true
};

export default VerticalSlideIn;
